import { Injectable, Inject } from '@roai/framework';
import type { IDeviceInfo } from './types';
import {
  getApplicationInfo,
  getSystemInfo,
  getDeviceInfo,
  getLocationInfo,
  getNetworkInfo,
  getSecurityInfo,
  getUserInfo
} from './device-info';
import MouseBehavior from './detector/mouseBehavior';
import Common from './common';
import { reportCrash } from '../monitor';
import { IConfig } from '../adapter';

@Injectable()
export default class Info {
  private isRunning: boolean = false;
  private mouseBehavior: MouseBehavior;
  private gdpr: boolean = false;
  private devInfo: Nullable<IDeviceInfo> = null;
  private common: Common;

  constructor(
    @Inject('Config') private config: IConfig
  ) {
    this.mouseBehavior = new MouseBehavior();
    this.common = new Common(this.config);
  }
  /**
   * 
   * @param gdpr 用户是否已经同意 GDPR 协议
   * @returns 
   */
  public start(gdpr: boolean) {
    if (this.isRunning) {
      return;
    }
    this.gdpr = gdpr;
    this.isRunning = true;
      
    this.mouseBehavior.start();
  }

  public stop() {
    this.isRunning = false;
    this.mouseBehavior.stop(); 
  }

  public async getCommonInfo() {
    const info = await this.common.getCommonInfo();
    return info;
  }

  public async getDeviceInfo(): Promise<Nullable<IDeviceInfo>> {
    const moveInfo = this.mouseBehavior.getMoveInfo();

    if (this.devInfo) {
      return {
        ...this.devInfo,
        g: {
          ...this.devInfo.g,
          gd: moveInfo,
        } 
      }
    }

    const gdpr = this.gdpr;

    try {
      const [
        a,
        b,
        c,
        d,
        e,
        f,
        g,
      ] = await Promise.all(
        [
          getDeviceInfo(gdpr, this.config.storage),
          getSystemInfo(gdpr),
          getNetworkInfo(gdpr),
          getUserInfo(),
          getApplicationInfo(gdpr),
          getLocationInfo(),
          getSecurityInfo(),
        ]
      );

      const devInfo = {
        a,
        b,
        c,
        d,
        e,
        f,
        g: {
          ...g,
          gd: moveInfo,
        }
      };

      this.devInfo = devInfo;

      return devInfo;

    } catch (e) {
      reportCrash({
        customData: {
          _$: 'Info.getDeviceInfo',
        },
        stackTrace: e.stack || e.message || '',
      })
      return null
    }
  }
}
